import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

const chiave = (id) => `xmove-tendina-${id}`;

/** Sezione a tendina del pannello: il contenuto viene montato solo quando è aperta. */
export const Tendina = ({ id, titolo, descrizione, icona: Icona, badge, children }) => {
  const [aperta, setAperta] = useState(() => localStorage.getItem(chiave(id)) === "1");
  useEffect(() => localStorage.setItem(chiave(id), aperta ? "1" : "0"), [id, aperta]);

  return (
    <div className="mt-5 overflow-hidden rounded-2xl border border-xmove-ink/10 bg-white shadow-soft" data-testid={`tendina-${id}`}>
      <button
        type="button"
        onClick={() => setAperta((v) => !v)}
        aria-expanded={aperta}
        data-testid={`tendina-${id}-toggle`}
        className="flex w-full items-center gap-4 px-5 py-4 text-left transition-colors hover:bg-xmove-cream/60"
      >
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-xmove-night text-xmove-orange">
          <Icona size={18} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="flex flex-wrap items-center gap-2">
            <span className="font-display text-lg font-bold text-xmove-ink">{titolo}</span>
            {badge && (
              <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${badge.tipo === "alert" ? "bg-red-100 text-red-700" : "bg-xmove-cream text-xmove-muted"}`} data-testid={`tendina-${id}-badge`}>
                {badge.testo}
              </span>
            )}
          </span>
          <span className="mt-0.5 block text-xs text-xmove-muted">{descrizione}</span>
        </span>
        <ChevronDown size={18} className={`shrink-0 text-xmove-muted transition-transform duration-300 ${aperta ? "rotate-180" : ""}`} />
      </button>
      {aperta && <div className="border-t border-xmove-ink/8 px-5 pb-8 [&>section]:!mt-6" data-testid={`tendina-${id}-body`}>{children}</div>}
    </div>
  );
};
